<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          variant="outline-primary"
          :to="{ name: 'groups-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <!-- Filters -->
    <groups-list-filters :search-query.sync="searchQuery" />
    <!-- Table Container Card -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('Show') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ $t('entries') }}</label>
            </b-col>
            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end" />
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="itemsData"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: Name -->
          <template #cell(name)="row">
            <b-link
              :to="{ name: 'groups-edit', params: { id: row.item.id } }"
              class="font-weight-bold "
            > {{ row.item.name }} </b-link>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="row">
            <!-- <b-button
              v-if="$can('group.assignWorkflow', 'Group')"
              v-b-tooltip
              class="btn-icon "
              variant="outline-primary"
              title="Cấp luồng cho nhóm"
              size="sm"
              :to="{ name: 'groups-assign-workflow', params: { id: row.item.id } }"
            >
              <feather-icon icon="GitPullRequestIcon" />
            </b-button>
            <b-button
              v-if="$can('group.assignRole', 'Group')"
              v-b-tooltip
              class="btn-icon ml-1"
              variant="outline-primary"
              title="Cấp quyền cho nhóm"
              size="sm"
              :to="{ name: 'groups-assign-role', params: { id: row.item.id } }"
            >
              <feather-icon icon="ShieldIcon" />
            </b-button>
            <b-button
              v-if="$can('group.assignUser', 'Group')"
              v-b-tooltip
              class="btn-icon ml-1"
              variant="outline-primary"
              title="Thêm user cho nhóm"
              size="sm"
              :to="{ name: 'groups-assign-user', params: { id: row.item.id } }"
            >
              <feather-icon icon="UsersIcon" />
            </b-button> -->
            <b-button
              v-if="$can('group.update', 'Group')"
              v-b-tooltip
              class="btn-icon ml-1"
              variant="outline-primary"
              title="Cập nhật"
              size="sm"
              :to="{ name: 'groups-edit', params: { id: row.item.id } }"
            >
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button
              v-if="$can('group.destroy', 'Group')"
              v-b-tooltip
              class="btn-icon ml-1"
              variant="outline-danger"
              title="Xóa"
              size="sm"
              @click="confirmDelete(row.item.id)"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <!-- Modal Assgin Workflow and Role -->
    <b-modal
      id="modalGroupAssign"
      title="Gán nhóm quyền"
      size="lg"
      :ok-only="true"
      ok-title="Đóng"
      hide-footer
      center
    >
      <groups-assign :group-data="groupData" />
    </b-modal>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BRow, BCol, BButton, BTable,
  BPagination, VBTooltip, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { showToast } from '@/@core/utils/utils'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import GroupsListFilters from './GroupsListFilters.vue'
import GroupsAssign from './GroupsAssign.vue'
import useGroups from './useGroups'

export default {
  components: {
    AppBreadcrumb,
    GroupsListFilters,
    GroupsAssign,
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BLink,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const isAddNewUserSidebarActive = ref(false)
    const groupOptions = ref([])

    const {
      loading,
      groupData,
      fetchGroups,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,

      // UI
      resolveUserGroupVariant,
      resolveUserGroupIcon,
      resolveUserStatusVariant,
      resolveUserStatusText,

      // Extra Filters
      groupFilter,
      planFilter,
      statusFilter,

      statusOptions,
    } = useGroups()

    fetchGroups();

    return {
      groupData,
      fetchGroups,
      // Sidebar
      isAddNewUserSidebarActive,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,

      // Filter
      avatarText,

      // UI
      resolveUserGroupVariant,
      resolveUserGroupIcon,
      resolveUserStatusVariant,
      resolveUserStatusText,

      groupOptions,
      statusOptions,

      // Extra Filters
      groupFilter,
      planFilter,
      statusFilter,

    }
  },
  methods: {
    openAssignModal(item) {
      this.groupData = item
      this.$bvModal.show('modalGroupAssign')
    },
    confirmDelete(id) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('groups/deleteGroup', { id }).then((res) => {
            if (res.status === 200) {
              this.fetchGroups();
              showToast(res.data.message, { variant: 'success' });
            } else {
              showToast(res.data.message);
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
